import { render, staticRenderFns } from "./DiagnosticGraph.vue?vue&type=template&id=36756a00"
import script from "./DiagnosticGraph.vue?vue&type=script&lang=js"
export * from "./DiagnosticGraph.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticGraph.vue?vue&type=style&index=0&id=36756a00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports